export class MarketDepthMatrixModel {
setValue(res){
if(res){
}
}
}